<template>
<!--  todo complete this after model-pages   -->
  <div id="layoutSidenav_nav">
    <nav class="sb-sidenav accordion sb-sidenav-dark bg-white" id="sidenavAccordion">
      <div class="sb-sidenav-menu e-bg-red rounded">
        <ul class="nav navbar-nav p-2">
          <template v-if="user.vessel_id == null">
            <div class="text-white pt-4 cursor-pointer" @click="showDashboard = !showDashboard" :class="showDashboard === false ? 'mb-3' : ''">
              <font-awesome-icon icon="clipboard" class="force-white-all" style="width: 25px" />
              DASHBOARD
              <span v-if="showDashboard" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showDashboard">
              <router-link
                class="nav-item e-text-white ml-4" :class="{'active': isUnderNumberOfManagement }" :to="{ name: 'NumberOfManagement', params : {
              report_type : 'flag'
            }}">
                <font-awesome-icon icon="th-large" class="force-white-all" style="width: 25px" />
                <small>VESSEL / CREW INFO</small>
              </router-link>
              <router-link class="nav-item e-text-white ml-4" :class="{'active': isUnderAiDashBoard}" :to="{ name: 'AiDashboard', params : {
              chart_module : 'number_of_report'
            }}">
                <font-awesome-icon icon="th-large" class="force-white-all" style="width: 25px" />
                <small>ACCIDENT / INCIDENT</small>
              </router-link>
              <router-link class="nav-item e-text-white ml-4" :to="{ name: 'PscDashboard'}">
                <font-awesome-icon icon="th-large" class="force-white-all" style="width: 25px" />
                <small>PSC INSPECTION</small>
              </router-link>
              <router-link class="nav-item e-text-white ml-4" :class="{'active': isUnderRsDashBoard}" :to="{ name: 'RsDashboard', params : {
              chart_module : 'number_of_findings'
            }}">
                <font-awesome-icon icon="th-large" class="force-white-all" style="width: 25px" />
                <small>RIGHTSHIP</small>
              </router-link>
              <template v-if="isVesselOrInstructor()">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'ShipsPiAccidentIncident'}" :class="{'router-link-active': isUnderVesselsPi}">
                  <!--v-if="isAllowed('menu.ships-pi')"-->
                  <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                  <small>VESSEL'S PI</small>
                </router-link>
              </template>
              <template v-if="user.username === 'skohei' || user.username === 'k-senju' || user.username === 'i-torregosa' || user.username === 'f-wang' || isElite()">
<!--                <a class="nav-item e-text-white ml-4 e-bg-red-light-3 no-hover">-->
<!--                  <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />-->
<!--                  <small>-->
<!--                    INVESTIGATION-->
<!--                  </small>-->
<!--                </a>-->
                <router-link class="nav-item e-text-white ml-4" :class="{'active': isUnderInvDashboard}" :to="{ name: 'InvestigationDashboard', params : {
                  chart_module : 'number_of_report'
                }}">
                  <font-awesome-icon icon="th-large" class="force-white-all" style="width: 25px" />
                  <small>INVESTIGATION</small>
                </router-link>
              </template>
            </template>
          </template>
          <hr class="my-0" />
          <div class="text-white pt-4 cursor-pointer" @click="showReportList = !showReportList" :class="showReportList === false ? 'mb-3' : ''">
            <font-awesome-icon icon="clipboard" class="force-white-all" style="width: 25px" />
            REPORT LIST
            <span v-if="showReportList" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
            <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
          </div>
          <template v-if="showReportList">
            <router-link class="nav-item e-text-white ml-4" :to="{ name: 'Module'}"
                         v-if="isAllowed('menu.reports.accident-incident')">
              <font-awesome-icon icon="notes-medical" class="force-white-all" style="width: 25px" />
              <small>
                ACCIDENT / INCIDENT
              </small>
            </router-link>
            <template v-else>
              <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  ACCIDENT / INCIDENT
                </small>
              </a>
            </template>
            <hr class="ml-4 my-0" />
            <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="showSafetyhealth = !showSafetyhealth" :class="showSafetyhealth === false ? 'mb-3' : ''">
              SAFETY HEALTH
              <span v-if="showSafetyhealth" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showSafetyhealth">
              <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  MEDICAL REPORT
                </small>
              </a>

              <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                <font-awesome-icon icon="file" class="force-white-all" style="width: 25px" />
                <small>
                  NEAR MISS REPORT
                </small>
              </a>

              <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                <font-awesome-icon icon="shield-alt" class="force-white-all" style="width: 25px" />
                <small>
                  P&I INSURANCE
                </small>
              </a>
            </template>
            <hr class="ml-4 my-0" />
            <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="showInspection = !showInspection" :class="showInspection === false ? 'mb-3' : ''">
              INSPECTION
              <span v-if="showInspection" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showInspection">
              <router-link class="nav-item e-text-white ml-4" :class="{'active':$route.name ==='PscIndex'}" :to="{ name: 'Psc'}"
                           v-if="isAllowed('menu.reports.psc-inspection')">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  PSC
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    PSC
                  </small>
                </a>
              </template>

<!--              <router-link class="nav-item e-text-white ml-4" :class="{'active':$route.name ==='RsIndex'}" :to="{ name: 'Rightship'}">-->
<!--                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />-->
<!--                <small>-->
<!--                  RIGHTSHIP-->
<!--                </small>-->
<!--              </router-link>-->

              <router-link class="nav-item e-text-white ml-4" :class="{'active':$route.name ==='RsIndex'}" :to="{ name: 'Rightship'}"
                           v-if="user.is_vessel === true || isAllowed('menu.reports.rightship-inspection') || isElite()">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  RIGHTSHIP
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    RIGHTSHIP
                  </small>
                </a>
              </template>
            </template>

            <!-- INTERNAL AUDIT -->
<!--            <br v-else>-->
            <hr class="ml-4 my-0" />
            <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3"
                 @click="showInternalAudit = !showInternalAudit" :class="showInternalAudit === false ? 'mb-3' : ''"
            >
              INTERNAL AUDIT
              <span v-if="showInternalAudit" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showInternalAudit">
              <ul class="nav navbar-nav ml-2" v-if="user.is_vessel === false">
                <div class="text-white mt-2 ml-2 pl-3 cursor-pointer mt-3"
                     @click="showVesselAudit = !showVesselAudit" :class="showVesselAudit === false ? 'mb-3' : ''"
                >
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  VESSEL AUDIT
                  <span v-if="showVesselAudit" class="force-white-all">
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                  <span v-else class="force-white-all">
                    <font-awesome-icon icon="chevron-right"/>
                  </span>
                </div>
                <template v-if="showVesselAudit">
                  <template v-if="user.is_vessel === false">
                    <template v-if="isAllowed('menu.reports.internal-audit-label.vessel-audit')">
                      <router-link class="nav-item e-text-white custom-ml-5"
                                   :class="{'active': $route.name === 'VesselAuditDue'}"
                                   :to="{ name: 'VesselAuditDue'}"
                                   >
                        <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT DUE
                        </small>
                      </router-link>
                      <router-link class="nav-item e-text-white custom-ml-5"
                                   :class="{'active': $route.name === 'VesselList'}"
                                   :to="{ name: 'VesselList'}"
                      >
                        <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT RECORDS
                        </small>
                      </router-link>
                      <router-link class="nav-item e-text-white custom-ml-5"
                                   :class="{'active': $route.name === 'ObjectiveEvidenceList'}"
                                   :to="{ name: 'ObjectiveEvidenceList'}"
                      >
                        <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                        <small>
                          OBJECTIVE EVIDENCE
                        </small>
                      </router-link>
                    </template>
                    <template v-else>
                      <a class="nav-item e-text-white e-bg-red-light-3 custom-ml-5 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT DUE
                        </small>
                      </a>
                      <a class="nav-item e-text-white e-bg-red-light-3 custom-ml-5 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT RECORDS
                        </small>
                      </a>
                      <a class="nav-item e-text-white e-bg-red-light-3 custom-ml-5 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          OBJECTIVE EVIDENCE
                        </small>
                      </a>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="isAllowed('menu.reports.internal-audit-label.vessel-audit')">
                      <router-link class="nav-item e-text-white ml-4"
                                   :class="{'active': isUnderVesselAudit}"
                                   :to="{ name: 'VesselAuditRecordList',
                                     params : {
                                     vessel_id : user.vessel_id
                                     }
                                    }"

                      >
                        <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT DUE
                        </small>
                      </router-link>
                    </template>
                    <template v-else>
                      <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT DUE
                        </small>
                      </a>
                    </template>
                  </template>
                </template>
              </ul>
              <template v-else>
                <ul class="nav navbar-nav ml-2">
                  <div class="text-white mt-2 ml-2 pl-3 cursor-pointer mt-3"
                       @click="showVesselAudit = !showVesselAudit" :class="showVesselAudit === false ? 'mb-3' : ''"
                  >
                    <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                    VESSEL AUDIT
                    <span v-if="showVesselAudit" class="force-white-all">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
                    <span v-else class="force-white-all">
                      <font-awesome-icon icon="chevron-right"/>
                    </span>
                  </div>
                  <template v-if="showVesselAudit">
                    <template v-if="isAllowed('menu.reports.internal-audit-label.vessel-audit')">
                      <router-link class="nav-item e-text-white custom-ml-5"
                                   :class="{'active': $route.name === 'VesselAuditDue'}"
                                   :to="{ name: 'VesselAuditDue'}"
                      >
                        <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT DUE
                        </small>
                      </router-link>
                      <router-link class="nav-item e-text-white custom-ml-5"
                                     :class="{'active': $route.name === 'VesselList'}"
                                     :to="{ name: 'VesselAuditRecordList',
                                      params : {
                                        vessel_id : user.vessel_id
                                      }
                                     }"
                      >
                        <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT RECORDS
                        </small>
                      </router-link>
                    </template>
                    <template v-else>
                      <a class="nav-item e-text-white e-bg-red-light-3 custom-ml-5 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT DUE
                        </small>
                      </a>
                      <a class="nav-item e-text-white e-bg-red-light-3 custom-ml-5 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          AUDIT RECORDS
                        </small>
                      </a>
                    </template>
                  </template>
                </ul>
              </template>

              <hr class="ml-4 my-0" />

              <ul class="nav navbar-nav ml-2">
                <div class="text-white mt-2 ml-2 pl-3 cursor-pointer mt-3"
                     @click="showAuditors = !showAuditors" :class="showAuditors === false ? 'mb-3' : ''"
                >
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  AUDIT TEAM
                  <span v-if="showAuditors" class="force-white-all">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
                  <span v-else class="force-white-all">
                      <font-awesome-icon icon="chevron-right"/>
                    </span>
                </div>
                <template v-if="showAuditors">
                  <template v-if="isAllowed('menu.reports.internal-audit-label.audit-team')">
                    <router-link  class="nav-item e-text-white ml-4" :class="{'active':$route.name ==='InternalAudit'}" :to="{ name: 'AuditorList'}"
                                  v-if="isAllowed('menu.reports.internal-audit-label.audit-team')">
                      <font-awesome-icon icon="users" class="force-white-all" style="width: 25px" />
                      <small>
                        LIST OF AUDITORS
                      </small>
                    </router-link>

                    <router-link  class="nav-item e-text-white ml-4" :class="{'active':$route.name ==='InternalAudit'}" :to="{ name: 'AuditorDPList'}"
                                  v-if="isAllowed('menu.reports.internal-audit-label.audit-team')">
                      <font-awesome-icon icon="users" class="force-white-all" style="width: 25px" />
                      <small>
                        LIST OF DP CERTIFICATES
                      </small>
                    </router-link>
                    <template v-else>
                      <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          LIST OF AUDITORS
                        </small>
                      </a>
                      <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                        <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                        <small>
                          LIST OF DP CERTIFICATES
                        </small>
                      </a>
                    </template>
                  </template>
                </template>
              </ul>

              <hr class="ml-4 my-0" />

              <router-link  class="nav-item e-text-white ml-4" :class="{'active': isUnderVPIStatus}" :to="{ name: 'VPIIntroduction'}"
                            v-if="isAllowed('menu.reports.internal-audit-label.vpi-status')">
                <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                <small>
                  VPI STATUS
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    VPI STATUS
                  </small>
                </a>
              </template>
<!--              <router-link  class="nav-item e-text-white ml-4" :class="{'active': isUnderCompanyAudit}" :to="{ name: 'CompanyList'}"-->
<!--                            v-if="isAllowed('menu.reports.internal-audit-label.company-audit')">-->
<!--                <font-awesome-icon icon="briefcase" class="force-white-all" style="width: 25px" />-->
<!--                <small>-->
<!--                  COMPANY AUDIT-->
<!--                </small>-->
<!--              </router-link>-->
            </template>
            <hr class="ml-4 my-0" />
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover"
               v-if="isAllowed('menu.reports.master-review')">
              <font-awesome-icon icon="chart-line" class="force-white-all" style="width: 25px;" />
              <small>
                MASTER'S REVIEW AND IMPROVEMENT
              </small>
            </a>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />
              <small>
                NEAR MISS REPORT
              </small>
            </a>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />
              <small>
                SUPERINTENDENT VISITING REPORT
              </small>
            </a>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />
              <small>
                SUPERINTENDENT INSTRUCTION TO SHIP
              </small>
            </a>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />
              <small>
                DEFICIENCY REPORT
              </small>
            </a>
          </template>
          <hr class="my-0" />
          <template v-if="user.vessel_id == null">
            <div class="text-white pt-4 cursor-pointer" @click="showCompanyInstruction = !showCompanyInstruction" :class="showCompanyInstruction === false ? 'mb-3' : ''">
              <font-awesome-icon icon="clipboard" class="force-white-all" style="width: 25px" />
              COMPANY INSTRUCTION
              <span v-if="showCompanyInstruction" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showCompanyInstruction">
              <router-link class="nav-item e-text-white ml-4"
                           :to="{ name: 'StaffCiAir', query:{type:'air',t:new Date().getTime()}}"

                           v-if="isAllowed('menu.company-instruction.accident-incident')">
                <font-awesome-icon icon="notes-medical" class="force-white-all" style="width: 25px" />
                <small>
                  ACCIDENT / INCIDENT
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    ACCIDENT / INCIDENT
                  </small>
                </a>
              </template>
              <router-link class="nav-item e-text-white ml-4"
                           :to="{ name: 'StaffCiPsc',query:{type:'psc',t:new Date().getTime()}}"
                           v-if="isAllowed('menu.company-instruction.psc-inspection')">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  PSC INSPECTION
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    PSC INSPECTION
                  </small>
                </a>
              </template>
              <router-link class="nav-item e-text-white ml-4"
                           :to="{ name: 'StaffCiRs',query:{type:'rs',t:new Date().getTime()}}"
                           v-if="isAllowed('menu.company-instruction.rightship-inspection')">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  RIGHTSHIP INSPECTION
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    RIGHTSHIP INSPECTION
                  </small>
                </a>
              </template>
              <router-link class="nav-item e-text-white ml-4"
                           :to="{ name: 'StaffCiOe',query:{type:'ia_oe',t:new Date().getTime()}}"
                           v-if="isAllowed('menu.company-instruction.vessel-audit')">
                <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                <small>
                  VESSEL AUDIT
                </small>
              </router-link>
              <template v-else>
                <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
                  <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
                  <small>
                    VESSEL AUDIT
                  </small>
                </a>
              </template>
            </template>
          </template>
          <template v-else>
            <div class="text-white pt-4 cursor-pointer" @click="showCompanyInstruction = !showCompanyInstruction" :class="showCompanyInstruction === false ? 'mb-3' : ''">
              <font-awesome-icon icon="clipboard" class="force-white-all" style="width: 25px" />
              COMPANY INSTRUCTION
              <span v-if="showCompanyInstruction" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showCompanyInstruction">
              <router-link class="nav-item e-text-white ml-4" :to="{ name: 'MasterCiAir',query:{type:'air',t:new Date().getTime()}}">
                <font-awesome-icon icon="notes-medical" class="force-white-all" style="width: 25px" />
                <small>
                  ACCIDENT / INCIDENT
                </small>
              </router-link>
              <router-link class="nav-item e-text-white ml-4" :to="{ name: 'MasterCiPsc',query:{type:'psc',t:new Date().getTime()}}">
                <font-awesome-icon icon="notes-medical" class="force-white-all" style="width: 25px" />
                <small>
                  PSC INSPECTION
                </small>
              </router-link>
              <router-link class="nav-item e-text-white ml-4" :to="{ name: 'MasterCiRs',query:{type:'rs',t:new Date().getTime()}}">
                <font-awesome-icon icon="notes-medical" class="force-white-all" style="width: 25px" />
                <small>
                  RIGHTSHIP INSPECTION
                </small>
              </router-link>

              <router-link class="nav-item e-text-white ml-4" :to="{ name: 'MasterCiOe',query:{type:'ia_oe',t:new Date().getTime()}}">
                <font-awesome-icon icon="notes-medical" class="force-white-all" style="width: 25px" />
                <small>
                  VESSEL AUDIT
                </small>
              </router-link>
            </template>

          </template>
          <hr class="my-0" />
          <template v-if="isAllowed('menu.vessels')">
            <router-link class="nav-item e-text-white" :to="{ name: 'Vessel'}"
                         v-if="user.vessel_id == null">
              <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
              <small>VESSELS</small>
            </router-link>
            <router-link class="nav-item e-text-white" :to="`/vessels/${user.vessel_id}/particular`"
                         v-else>
              <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
              <small>VESSEL</small>
            </router-link>
            <hr class="my-0" />
          </template>
          <template v-else>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
              <small>
                VESSELS
              </small>
            </a>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
              <small>
                VESSEL
              </small>
            </a>
          </template>


<!--          <template v-if="isAllowed('menu.vessels')">-->
<!--            <router-link class="nav-item e-text-white" :to="{ name: 'Company'}">-->
<!--              <font-awesome-icon icon="building" class="force-white-all" style="width: 25px" />-->
<!--              COMPANIES-->
<!--            </router-link>-->
<!--            <hr class="my-0" />-->
<!--          </template>-->

<!--          Temporary Fix for User Role - Vessel & Instructor-->
<!--          <template v-if="isVesselOrInstructor()">-->
          <router-link class="nav-item e-text-white" :to="{ name: 'ContactList'}">
            <font-awesome-icon icon="file-pdf" class="force-white-all" style="width: 25px" />
            <small>CONTACT LIST</small>
          </router-link>
          <a class="nav-item e-text-white" href="https://www.krbs-udon.com/auth/login?redirect=/" target="_blank" v-if="isAllowed('menu.kscm')">
            <font-awesome-icon icon="certificate" class="force-white-all" style="width: 25px" />
            <small>KSCM</small>
          </a>
          <template v-else>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
              <small>
                KSCM
              </small>
            </a>
          </template>

          <a class="nav-item e-text-white" href="https://krbsgroup.com/memo-circular/" target="_blank" v-if="isAllowed('menu.kocs')">
            <font-awesome-icon icon="landmark" class="force-white-all" style="width: 25px" />
            <small>KOCS</small>
          </a>
          <template v-else>
            <a class="nav-item e-text-white e-bg-red-light-3 ml-4 no-hover">
              <font-awesome-icon icon="file-contract" class="force-white-all" style="width: 25px" />
              <small>
                KOCS
              </small>
            </a>
          </template>
<!--          </template>-->

          <template v-if="isElite()">
            <hr class="my-0" />
            <div class="text-white pt-4 cursor-pointer" @click="showSettings = !showSettings">
              <font-awesome-icon icon="cogs" class="force-white-all" style="width: 25px" />
              SETTINGS
              <span v-if="showSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
            </div>
            <template v-if="showSettings && isElite()">
              <!-- SYSTEM SETTINGS AREA START -->
              <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleSystemSettings" :class="showSystemSettings === false ? 'mb-3' : ''">
                SYSTEM
                <span v-if="showSystemSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
                <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
              </div>
              <template v-if="showSystemSettings">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsUsers'}"
                             v-if="isAllowed('menu.settings.user')">
                  <font-awesome-icon icon="users" class="force-white-all" style="width: 25px" />
                  <small>
                    USERS
                  </small>
                </router-link>

                <hr class="ml-4 my-0" />

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingAnnouncement'}"
                             v-if="isAllowed('menu.settings.user')">
                  <font-awesome-icon icon="bullhorn" class="force-white-all" style="width: 25px" />
                  <small>
                    NEWS / ANNOUNCEMENT
                  </small>
                </router-link>

                <hr class="ml-4 my-0" />

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingEmails'}"
                             v-if="isAllowed('menu.settings.emails') === false">
                  <font-awesome-icon icon="envelope" class="force-white-all" style="width: 25px" />
                  <small>
                    EMAILS
                  </small>
                </router-link>
              </template>
              <!-- SYSTEM SETTINGS AREA END -->

              <hr class="ml-4 my-0" />

              <!-- SYSTEM SETTINGS EXCHANGE RATES AREA START -->
              <div class="text-white mt-3 ml-3 pl-3 cursor-pointer" @click="toggleSystemSettingsDashboard" :class="showSettingsDashboard === false ? 'mb-3' : ''">
                DASHBOARD
                <span v-if="showSettingsDashboard" class="force-white-all">
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                <span v-else class="force-white-all">
                    <font-awesome-icon icon="chevron-right"/>
                  </span>
              </div>
              <template v-if="showSettingsDashboard">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsExchangeRates'}"
                             v-if="true">
                  <font-awesome-icon icon="percent" class="force-white-all" style="width: 25px" />
                  <small>
                    EXCHANGE RATES
                  </small>
                </router-link>
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsExchangeRatesCurrencies'}"
                             v-if="true">
                  <font-awesome-icon icon="money-bill" class="force-white-all" style="width: 25px" />
                  <small>
                    EXCHANGE CURRENCIES
                  </small>
                </router-link>
              </template>
              <!-- SYSTEM SETTINGS EXCHANGE RATES AREA END -->

              <hr class="ml-4 my-0" />

              <!-- SHOW INCIDENT SETTINGS AREA START -->
              <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleIncidentSettings " :class="showAccidentIncidentSettings === false ? 'mb-3' : ''">
                ACCIDENT / INCIDENT
                <span v-if="showAccidentIncidentSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
                <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
              </div>
              <template v-if="showAccidentIncidentSettings">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsCurrencies'}"
                             v-if="isAllowed('menu.settings.currency')">
                  <font-awesome-icon icon="money-bill" class="force-white-all" style="width: 25px" />
                  <small>
                    CURRENCIES
                  </small>
                </router-link>
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsEvents'}"
                             v-if="isAllowed('menu.settings.event')">
                  <font-awesome-icon icon="calendar" class="force-white-all" style="width: 25px" />
                  <small>
                    EVENTS
                  </small>
                </router-link>
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsCauses'}"
                             v-if="isAllowed('menu.settings.cause')">
                  <font-awesome-icon icon="car-crash" class="force-white-all" style="width: 25px" />
                  <small>
                    CAUSES
                  </small>
                </router-link>
              </template>
              <!-- SHOW INCIDENT SETTINGS AREA END -->

              <hr class="ml-4 my-0" />

              <!-- VESSEL SETTINGS AREA START -->
              <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleVesselSettings" :class="showVesselSettings === false ? 'mb-3' : ''">
                VESSEL
                <span v-if="showVesselSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
                <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
              </div>
              <template v-if="showVesselSettings">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SisterShip'}"
                             v-if="isAllowed('menu.settings.sister-ship')">
                  <font-awesome-icon icon="users" class="force-white-all" style="width: 25px" />
                  <small>
                    SISTER SHIP
                  </small>
                </router-link>
                <!--            v-if="isAllowed('menu.settings.sister-ship')"-->
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'RelatedParty'}">
                  <font-awesome-icon icon="users" class="force-white-all" style="width: 25px" />
                  <small>
                    RELATED PARTIES
                  </small>
                </router-link>
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'ShipBuilder'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    SHIP BUILDER
                  </small>
                </router-link>

                <!-- SHOW MANAGING VESSEL SETTINGS AREA START -->
                <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleManagingVesselSettings " :class="showManagingVesselSettings === false ? 'mb-3' : ''">
                  MANAGING VESSEL
                  <span v-if="showManagingVesselSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
                  <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
                </div>
                <template v-if="showManagingVesselSettings">
                  <router-link class="nav-item e-text-white ml-4" :to="{ name: 'ManagingVessel'}">
                    <font-awesome-icon icon="ship" class="force-white-all" style="width: 25px" />
                    <small>
                      MANAGING VESSEL
                    </small>
                  </router-link>

                  <router-link class="nav-item e-text-white ml-4" :to="{ name: 'HistoryLogs'}" v-if="isElite">
                    <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />
                    <small>
                      HISTORY LOGS
                    </small>
                  </router-link>
                </template>
                <!-- SHOW MANAGING VESSEL SETTINGS AREA END -->
                <!-- SHOW INTERNAL AUDIT SETTINGS AREA START -->
                <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleInternalAuditSettings " :class="showInternalAuditSettings === false ? 'mb-3' : ''">
                  INTERNAL AUDIT
                  <span v-if="showInternalAuditSettings" class="force-white-all">
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                  <span v-else class="force-white-all">
                    <font-awesome-icon icon="chevron-right"/>
                  </span>
                </div>
                <template v-if="showInternalAuditSettings">
                  <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingsChecklistMain'}" v-if="isElite">
                    <font-awesome-icon icon="file" class="force-white-all" style="width: 25px;" />
                    <small>
                      AUDIT CHECKLIST
                    </small>
                  </router-link>

                  <router-link class="nav-item e-text-white ml-4" :to="{ name: 'ShipAuditSchedule'}" v-if="isElite">
                    <font-awesome-icon icon="calendar" class="force-white-all" style="width: 25px" />
                    <small>
                      AUDIT SCHEDULE
                    </small>
                  </router-link>
                </template>
                <!-- SHOW INTERNAL AUDIT SETTINGS AREA END -->
              </template>
              <!-- VESSEL SETTINGS AREA END -->
              <hr class="ml-4 my-0" />
              <!-- ENGINES AREA START -->
              <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleEnginesDropdown" :class="showEnginesSettings === false ? 'mb-3' : ''">
                ENGINES
                <span v-if="showEnginesSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
                <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
              </div>
              <template v-if="showEnginesSettings">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineMaker'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    ENGINE MAKER
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineType'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    ENGINE TYPE
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineDgMaker'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    ENGINE D/G MAKER
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineDgType'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    ENGINE D/G TYPE
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineTcMaker'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    ENGINE T/C MAKER
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineTcType'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    ENGINE T/C TYPE
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineAuxMaker'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    AUX BOILER MAKER
                  </small>
                </router-link>

                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'EngineAuxType'}" v-if="isElite">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    AUX BOILER TYPE
                  </small>
                </router-link>
              </template>
              <!-- ENGINES FINDINGS AREA END -->

              <hr class="ml-4 my-0" />

              <!-- RIGHTSHIP RISQ FINDINGS AREA START -->
              <div class="text-white mt-2 ml-3 pl-3 cursor-pointer mt-3" @click="toggleRightShipDropdown" :class="showRightShipSettings === false ? 'mb-3' : ''">
                RIGHTSHIP
                <span v-if="showRightShipSettings" class="force-white-all">
                <font-awesome-icon icon="chevron-down"/>
              </span>
                <span v-else class="force-white-all">
                <font-awesome-icon icon="chevron-right"/>
              </span>
              </div>
              <template v-if="showRightShipSettings">
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingQuestionnaire'}"
                             v-if="isAllowed('menu.settings.user')">
                  <font-awesome-icon icon="users" class="force-white-all" style="width: 25px" />
                  <small>
                    RISQ QUESTIONNAIRES
                  </small>
                </router-link>
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingRevision'}"
                             v-if="isAllowed('menu.settings.user')">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    RISQ REVISION NUMBERS
                  </small>
                </router-link>
                <router-link class="nav-item e-text-white ml-4" :to="{ name: 'SettingInspection'}">
                  <font-awesome-icon icon="cog" class="force-white-all" style="width: 25px" />
                  <small>
                    INSPECTION SETTINGS
                  </small>
                </router-link>
              </template>
              <!-- RIGHTSHIP RISQ FINDINGS AREA END -->
            </template>

          </template>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: 'MainSidebar',
  data() {
    return {
      showDashboard : true,
      showReportList : true,
      showInspection : false,
      showInternalAudit : false,
      showCompanyInstruction : false,
      showSettings : true,
      showSettingsDashboard : false,
      roleChecker: null,
      showRightShipSettings : false,
      showAccidentIncidentSettings : false,
      showManagingVesselSettings : false,
      showInternalAuditSettings : false,
      showEnginesSettings : false,
      showVesselSettings : false,
      showVesselAudit: false,
      showSafetyhealth: false,
      showSystemSettings : false,
      showAuditors: false
    }
  },
  watch: {
    showInternalAudit(isInternalAuditShow){
      if(isInternalAuditShow === true){
        this.showVesselAudit = true
        this.showAuditors = true
      }
    },
    $route: {
      immediate: true,
      handler(newRoute) {
        this.updateRightShipToggle(newRoute);
        this.updateSystemToggle(newRoute);
        this.updateVesselToggle(newRoute);
        this.updateIncidentToggle(newRoute);
        this.updateManagingVesselToggle(newRoute);
        this.updateInternalAuditToggle(newRoute);
        this.updateEnginesToggle(newRoute);
      }
    }
  },
  methods: {
    updateEnginesToggle(route) {
      const enginesRoutes = [
        'SettingQuestionnaire',
        'SettingRevision',
        'EngineMaker',
        'EngineType',
        'EngineDgMaker',
        'EngineDgType',
        'EngineTcMaker',
        'EngineTcType',
        'EngineAuxMaker',
        'EngineAuxType'
      ];
      if (enginesRoutes.includes(route.name)) {
        this.showEnginesSettings = true;
      }
    },
    toggleEnginesDropdown() {
      this.showEnginesSettings = !this.showEnginesSettings;
    },
    updateRightShipToggle(route) {
      const risqRoutes = [
        'SettingQuestionnaire',
        'SettingRevision'
      ];
      if (risqRoutes.includes(route.name)) {
        this.showRightShipSettings = true;
      }
    },
    toggleRightShipDropdown() {
      this.showRightShipSettings = !this.showRightShipSettings;
    },
    updateSystemToggle(route) {
      const systemRoutes = [
        'SettingAnnouncement',
        'SettingsUsers',
        'SettingsExchangeRates'
      ];
      if (systemRoutes.includes(route.name)) {
        this.showSystemSettings = true;
      }

    },
    toggleSystemSettings() {
      this.showSystemSettings = !this.showSystemSettings;
      this.showSettingsDashboard = !this.showSettingsDashboard;
    },
    toggleSystemSettingsDashboard() {
      this.showSettingsDashboard = !this.showSettingsDashboard;
    },
    updateVesselToggle(route) {
      const vesselRoutes = [
        'SisterShip',
        'RelatedParty',
        'ManagingVessel',
        'HistoryLogs',
        'ShipBuilder',
      ];
      if (vesselRoutes.includes(route.name)) {
        this.showVesselSettings = true;
      }
    },
    toggleVesselSettings() {
      this.showVesselSettings = !this.showVesselSettings;
    },
    updateIncidentToggle(route) {
      const incidentRoutes = [
        'SettingsCurrencies',
        'SettingsEvents',
        'SettingsCauses'
      ];
      if (incidentRoutes.includes(route.name)) {
        this.showAccidentIncidentSettings = true;
      }
    },
    toggleIncidentSettings() {
      this.showAccidentIncidentSettings = !this.showAccidentIncidentSettings;
    },
    updateManagingVesselToggle(route) {
      const managingVesselRoutes = [
        'ManagingVessel',
        'HistoryLogs',
      ];
      if (managingVesselRoutes.includes(route.name)) {
        this.showManagingVesselSettings = true;
      }
    },
    toggleManagingVesselSettings() {
      this.showManagingVesselSettings = !this.showManagingVesselSettings;
    },
    updateInternalAuditToggle(route) {
      const internalAuditRoutes = [
        'SettingsChecklistMain'
      ];
      if (internalAuditRoutes.includes(route.name)) {
        this.showInternalAuditSettings = true;
      }
    },
    toggleInternalAuditSettings() {
      this.showInternalAuditSettings = !this.showInternalAuditSettings;
    },
    ...mapActions(['pullUserDetails']),
    async vesselOverview(vesselId) {
      await this.$router.push({
        name: "VesselParticular",
        params: {id: vesselId},
      });

    },
    isActiveRouteCompanyInstruction(routeName,type){
      let currentRouteName = this.$router.currentRoute.name
      if(currentRouteName==routeName){
        if(!!this.$route.query.type) return this.$route.query.type==type
      }
      return false;
    },

  },
  mixins: [permissionMixin],

  created () {
    this.pullUserDetails()
  //   todo call the permission getters to backend here
  },

  computed: {
    ...mapGetters(['user']),
    isUnderVesselAudit() {
      return this.$route.name === 'InternalAudit' ||
        this.$route.name === 'ObjectiveEvidence' ||
        this.$route.name === 'VesselAuditDue' ||
        this.$route.name === 'Audit' ||
        this.$route.name === 'internalAuditReport' ||
        this.$route.name === 'NonConformity' ||
        this.$route.name === 'NcrMainDetails' ||
        this.$route.name === 'VesselAuditRecordList' ||
        this.$route.name === 'ObjectiveEvidenceList' ||
        this.$route.name === 'ObjectiveEvidenceDetail' ||
        this.$route.name === 'OEMainDetails' ||
        this.$route.name === 'OEAttachments' ||
        this.$route.name === 'IaCompanyInstructions' ||
        this.$route.name === 'IaCorrectiveActionReport' ||
        this.$route.name === 'IAShipParticular';
    },
    isUnderCompanyAudit() {
      return this.$route.name === 'CompanyInternalAudit' ||
        this.$route.name === 'CompanyObjectiveEvidence' ||
        this.$route.name === 'CompanyAuditDue' ||
        this.$route.name === 'CompanyAudit' ||
        this.$route.name === 'CompanyInternalAuditReport' ||
        this.$route.name === 'CompanyNonConformity' ||
        this.$route.name === 'CompanyNcrMainDetails' ||
        this.$route.name === 'CompanyVesselAuditRecordList' ||
        this.$route.name === 'CompanyObjectiveEvidenceList' ||
        this.$route.name === 'CompanyObjectiveEvidenceDetail' ||
        this.$route.name === 'CompanyOEMainDetails' ||
        this.$route.name === 'CompanyOEAttachments' ||
        this.$route.name === 'CompanyIaCompanyInstructions' ||
        this.$route.name === 'CompanyIaCorrectiveActionReport' ||
        this.$route.name === 'CompanyIAShipParticular';
    },
    isUnderVPIStatus() {
      return this.$route.name === 'VPIIntroduction' ||
        this.$route.name === 'VPIGraph' ||
        this.$route.name === 'VPI';
    },
    isUnderAiDashBoard() {
      return this.$route.name === 'AiDashboard' || this.$route.name === 'SafetyAndHealth';
    },
    isUnderInvDashboard(){
      return this.$route.name === 'InvestigationDashboard';
    },
    isUnderRsDashBoard() {
      return this.$route.name === 'RsDashboard';
    },
    isUnderNumberOfManagement() {
      return this.$route.name === 'NumberOfManagement'
    },
    hasRightshipAccess(){
      return ['skohei', 'k-senju', 'i-torregosa','c-wayong', 'rp-bancolita'].includes(this.user.username);
    },
    isUnderVesselsPi() {
      return this.$route.name === 'VesselAccidentIncident' ||
        this.$route.name === 'ShipsPiPSCNumberDeficiency' ||
        this.$route.name === 'ShipsPiPSCNumberInspection' ||
        this.$route.name === 'ShipsPiPSCDetention' ||
        this.$route.name === 'WorkingEnvironments' ||
        this.$route.name === 'ShipsPiRightship';
    }
  }
}
</script>

<style scoped lang="scss">
.nav > a {
  margin: .35rem 0;
  padding: .5rem;
  border-radius: 5px;
  text-decoration: none;
  &:hover, &:hover * {
    background-color: white;
    color: #d3313c;
  }
}

.active {
  background-color: white;
  color: #d3313c;
  * {
    font-weight: 800;
    color: #d3313c;
  }
}
.router-link-active {
  background-color: white;
  font-weight: 800;
  color: #d3313c;
  * {
    color: #d3313c;
  }
}

.router-link-active small{
  background-color: white;
  font-weight: 800;
  color: #d3313c;
  * {
    color: #d3313c;
  }
}
.no-hover {
  pointer-events: none;
}

.cursor-pointer{
  cursor: pointer !important;
}

.custom-ml-5 {
  margin-left: 2.5rem !important;
}
</style>
